import { authStorage } from './authStorage';
import api, { refreshAccessToken } from './api';
import { decodeJwt, clearSession } from '../utils/session';

const authService = {
  // ─── JWT utilities (không cần gọi server) ───────────────────────────────

  decodeToken: (token) => {
    return decodeJwt(token);
  },

  isTokenExpired: (token) => {
    if (!token) return true;
    const payload = authService.decodeToken(token);
    if (!payload?.exp) return true;
    // Thêm 5 giây buffer để tránh race condition
    return payload.exp * 1000 <= Date.now() + 5000;
  },

  getTokenExpiry: (token) => {
    const payload = authService.decodeToken(token);
    return payload?.exp ? payload.exp * 1000 : null;
  },

  // ─── Auth API ────────────────────────────────────────────────────────────

  // Login
  login: async (credentials) => {
    const response = await api.post('/api/auth/login', credentials);
    const { accessToken, refreshToken, user } = response.data.data;

    // Store tokens and user info
    authStorage.setItem('accessToken', accessToken);
    authStorage.setItem('refreshToken', refreshToken);
    authStorage.setItem('user', JSON.stringify(user));
    authStorage.setItem('lastActiveTime', String(Date.now()));

    return response.data.data;
  },

  // Logout
  logout: async () => {
    const token = authStorage.getItem('accessToken');
    clearSession(authStorage);
    try {
      await api.post('/api/auth/logout', null, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
    } catch (error) {
      console.error('Logout error:', error);
    }
  },

  // Register
  register: async (userData) => {
    const response = await api.post('/api/auth/register', userData);
    return response.data.data;
  },

  // Get current user info
  getCurrentUser: async () => {
    const response = await api.get('/api/auth/me');
    const user = response.data.data;
    authStorage.setItem('user', JSON.stringify(user));
    return user;
  },

  // Change password
  changePassword: async (passwordData) => {
    const response = await api.post('/api/auth/change-password', passwordData);
    return response.data;
  },

  // Forgot password
  forgotPassword: async (data) => {
    const response = await api.post('/api/auth/forgot-password', data);
    return response.data;
  },

  // Refresh token
  refreshToken: () => refreshAccessToken(),

  // Check if user is authenticated (token tồn tại, không cần valid ở đây — checkAuth xử lý)
  isAuthenticated: () => {
    return !!authStorage.getItem('accessToken');
  },

  // Kiểm tra session còn hợp lệ không (cả access + refresh đều hết → false)
  isSessionValid: () => {
    const access  = authStorage.getItem('accessToken');
    const refresh = authStorage.getItem('refreshToken');
    if (!access) return false;
    // Access còn hạn → valid
    if (!authService.isTokenExpired(access)) return true;
    // Access hết nhưng refresh còn → có thể tự refresh → vẫn "valid"
    if (refresh && !authService.isTokenExpired(refresh)) return true;
    return false;
  },

  // Get stored user
  getStoredUser: () => {
    const userStr = authStorage.getItem('user');
    try { return userStr ? JSON.parse(userStr) : null; }
    catch { return null; }
  },
};

export default authService;

